import { Outlet } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Footer from './Footer';
import Header from './Header';
import Breadcrumbs from 'components/Breadcrumbs';
import NavigationScroll from 'components/NavigationScroll';
import UniversalMissionHeader from 'components/UniversalMissionHeader';
import CveLiveTicker from 'components/CveLiveTicker';
import MaintenanceBanner from 'components/MaintenanceBanner';
import AnnouncementBanner from 'components/AnnouncementBanner';
import MaintenanceGate from 'components/MaintenanceGate';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {

  return (
    <>
      <Drawer />
      <Header />
      <div className="pc-container">
        <div className="pc-content">
          <MaintenanceBanner />
          <AnnouncementBanner />
          <CveLiveTicker />
          <MaintenanceGate>
            <Breadcrumbs />
            <NavigationScroll>
              <UniversalMissionHeader />
              <Outlet />
            </NavigationScroll>
          </MaintenanceGate>
        </div>
      </div>
      <Footer />
    </>
  );
}
